export default __webpack_public_path__ + "static/O0037-85b448b9753b88a59b291dd14c2b48e2.png";